import React from 'react'

const SIZE_CONFIG = {
  thumb: {
    container: 'w-12 h-12',
    text: 'text-sm',
    pixels: 48
  },
  medium: {
    container: 'w-24 h-24',
    text: 'text-2xl',
    pixels: 96
  },
  large: {
    container: 'w-48 h-48',
    text: 'text-5xl',
    pixels: 192
  }
}

export default function TeamLogo({
  team,
  size = 'thumb',
  className = '',
  primaryColor = '#3366FF'
}) {
  const config = SIZE_CONFIG[size] || SIZE_CONFIG.thumb
  const logoUrl = team?.logo_url
  const teamName = team?.name || ''

  // Get first letter(s) for fallback avatar
  const initials = teamName.slice(0, 2)

  // If logo is available, display it
  if (logoUrl) {
    return (
      <div
        className={`${config.container} rounded-full overflow-hidden flex-shrink-0 border border-gray-200 ${className}`}
      >
        <img
          src={logoUrl}
          alt={`${teamName} logo`}
          className="w-full h-full object-cover"
        />
      </div>
    )
  }

  // Fallback: first-letter avatar
  return (
    <div
      className={`${config.container} rounded-full flex items-center justify-center text-white font-bold flex-shrink-0 ${config.text} ${className}`}
      style={{ backgroundColor: primaryColor }}
    >
      {initials}
    </div>
  )
}
